"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTypeValue = exports.ContentTypeValueMap = exports.HttpStatus = exports.Method = exports.ContentType = void 0;
var ContentType;
(function (ContentType) {
    ContentType["JSON"] = "JSON";
    ContentType["FORM"] = "FORM";
})(ContentType || (ContentType = {}));
exports.ContentType = ContentType;
var ContentTypeValue;
(function (ContentTypeValue) {
    ContentTypeValue["JSON"] = "application/json";
    ContentTypeValue["FORM"] = "application/x-www-form-urlencoded";
})(ContentTypeValue || (ContentTypeValue = {}));
exports.ContentTypeValue = ContentTypeValue;
var ContentTypeValueMap = new Map([
    [ContentType.JSON, ContentTypeValue.JSON],
    [ContentType.FORM, ContentTypeValue.FORM],
]);
exports.ContentTypeValueMap = ContentTypeValueMap;
var Method;
(function (Method) {
    Method["POST"] = "POST";
    Method["GET"] = "GET";
})(Method || (Method = {}));
exports.Method = Method;
/**
 * http状态码
 */
var HttpStatus;
(function (HttpStatus) {
    HttpStatus[HttpStatus["SUCCESS"] = 200] = "SUCCESS";
    HttpStatus[HttpStatus["NOT_FOUND"] = 404] = "NOT_FOUND";
})(HttpStatus || (HttpStatus = {}));
exports.HttpStatus = HttpStatus;
